module.exports = __webpack_public_path__ + "static/text_01-aba7153269b78b3be55a41e36adf4ad8.png";